import React, { Component, Fragment } from "react";
import Time from "react-time-format";
import NumberFormat from "react-number-format";
import { Tabs, TabList, Tab } from "react-tabs";
import Swal from "sweetalert2";
import PropertyesList from "../../Propertys_Agent/PropertyesList";
import { Button } from "antd";
export class ViewParadan extends Component {
 constructor(props) {
  super(props);
  this.state = {
   Amount: 0,
   currency: "",
   payer: "",
   reciver: "",
   from: "",
   to: "",
   type:
    this.props.lang === "en"
     ? "Monthly rent invoice"
     : this.props.lang === "krd"
     ? "کرێی مانگانە"
     : "فواتير الإيجار الشهري",
   save: null,
   instead_of: "",
   R_cursor: 0,
   List_names: [],
   tid: "",
   pedraw: "",
   updated: false,
   redirect: false,
   balanceRemian: 0,
   property: "",
   place: "",
   num: "",
   note: "",
   box_status: "",
   createdAt: "",
  };
 }
 onselect = (index) => {
  if (index === 0) {
   let type =
    this.props.lang === "en"
     ? "Monthly rent invoice"
     : this.props.lang === "krd"
     ? "کرێی مانگانە"
     : "فواتير الإيجار الشهري";
   this.setState({
    type: type,
   });
  } else if (index === 1) {
   let type =
    this.props.lang === "en"
     ? "Service Bill"
     : this.props.lang === "krd"
     ? "خزمەتگوزاری"
     : "فواتير الخدمات";
   this.setState({
    type: type,
   });
  } else if (index === 2) {
   let type =
    this.props.lang === "en"
     ? "Insurance Bill"
     : this.props.lang === "krd"
     ? "دڵنیایی"
     : "التأمين";
   this.setState({
    type: type,
   });
  } else if (index === 3) {
   let type =
    this.props.lang === "en"
     ? "Sell"
     : this.props.lang === "krd"
     ? "فرۆشتن"
     : "بيع";
   this.setState({
    type: type,
   });
  } else if (index === 4) {
   let type =
    this.props.lang === "en"
     ? "Buy"
     : this.props.lang === "krd"
     ? "کڕین"
     : "شراء";
   this.setState({
    type: type,
   });
  } else if (index === 5) {
   let type =
    this.props.lang === "en"
     ? "Arabun"
     : this.props.lang === "krd"
     ? "عربون"
     : "عربون";
   this.setState({
    type: type,
   });
  } else if (index === 6) {
   let type =
    this.props.lang === "en"
     ? "comision"
     : this.props.lang === "krd"
     ? "عمولە"
     : "عمولة";
   this.setState({
    type: type,
   });
  } else if (index === 7) {
   let type =
    this.props.lang === "en"
     ? "investor"
     : this.props.lang === "krd"
     ? "وەبەرهێنەر"
     : "مستثمر";
   this.setState({
    type: type,
   });
  }
 };
 componentDidUpdate(prevProps) {
  if (prevProps.view_paradan_obj !== this.props.view_paradan_obj) {
   this.setState({
    Amount: this.props.view_paradan_obj.Amount,
    currency: this.props.view_paradan_obj.currency,
    payer: this.props.view_paradan_obj.payer,
    reciver: this.props.view_paradan_obj.reciver,
    from: this.props.view_paradan_obj.from,
    to: this.props.view_paradan_obj.to,
    type: this.props.change_Lang(this.props.view_paradan_obj.type),
    instead_of: this.props.view_paradan_obj.instead_of,
    pedraw: this.props.view_paradan_obj.pedraw,
    updated: true,
    balanceRemian: this.props.view_paradan_obj.balanceRemian,
    place: this.props.view_paradan_obj.place,
    note: this.props.view_paradan_obj.note,
    property: this.props.view_paradan_obj.property,
    num: this.props.view_paradan_obj.num,
    box_status: this.props.view_paradan_obj.box_status,
    createdAt: this.props.view_paradan_obj.createdAt,
   });
  }
 }
 handleChange_Property = (value) => {
  this.setState({ property: value });
 };
 OnChangeHandler = (e) => {
  this.setState({
   [e.target.name]: e.target.value,
  });
 };
 onOpenUpdate = async () => {
  this.setState({ updated: false });
 };
 onCloseUpdate = () => {
  const {
   EveryTimeTo_English,
   change_Lang,
   Update_Paradan,
   view_paradan_obj,
   handleCancel,
   Get_List_Paradan,
  } = this.props;
  const data = {
   payer: this.state.payer,
   reciver: this.state.reciver,
   Amount: parseFloat(this.state.Amount.toString().replace(/,/g, "")),
   balanceRemian: parseFloat(
    this.state.balanceRemian.toString().replace(/,/g, "")
   ),
   currency: EveryTimeTo_English(this.state.currency),
   type: EveryTimeTo_English(this.state.type),
   instead_of: this.state.instead_of,
   pedraw: this.state.pedraw,
   from: this.state.from,
   to: this.state.to,
   note: this.state.note,
   property: this.state.property,
   place: this.state.place,
   num: this.state.num,
   box_status: this.state.box_status,
   createdAt: this.state.createdAt,
  };
  if (
   this.state.payer === "" ||
   this.state.Amount === "" ||
   this.state.Amount === 0 ||
   this.state.type === "" ||
   this.state.currency.toString().length === 0 ||
   this.state.box_status.toString().length === 0
  ) {
   Swal.fire({
    title: "OPS",
    text: change_Lang("Please Check Inputs"),
    icon: "error",
    html: `<b class="fk">${change_Lang("Please Check Inputs")}</b>`,
    confirmButtonText: change_Lang("Ok"),
    buttonsStyling: { fontFamily: "fk" },
    timer: 1300,
   });
  } else {
   Update_Paradan(view_paradan_obj._id, data);
   Get_List_Paradan();
   handleCancel();
   this.setState({ updated: true });
   Swal.fire({
    title: "Good job!",
    html: `<b class="fk">${change_Lang(
     "You successfully tainted your work"
    )}</b>`,
    icon: "success",
    confirmButtonText: change_Lang("success"),
    buttonsStyling: { fontFamily: "fk" },
    timer: 1000,
   });
  }
 };
 Paradan_getPrint = () => {
  window.setTimeout("window.print()", 4000);
 };
 render() {
  const {
   change_Lang,
   lang,
   view_paradan_obj,
   user,
   name_arb,
   name_krd,
   name_en,
  } = this.props;
  const {
   payer,
   reciver,
   Amount,
   updated,
   currency,
   from,
   to,
   place,
   property,
   note,
   num,
   instead_of,
   box_status,
   createdAt,
  } = this.state;
  const { OnChangeHandler, onCloseUpdate, onOpenUpdate, onselect } = this;
  return (
   <Fragment>
    <Tabs onSelect={(index) => onselect(index)}>
     <>
      <div className="row">
       <div className="col-md-4 d-flex justify-content-start">
        <label
         style={{ fontSize: "22px", color: "#295a68" }}
         className="product-page-details product-right mb-2 text-uppercase font-weight-bold"
        >
         {lang === "krd" ? name_krd : lang === "arb" ? name_arb : name_en}
        </label>
       </div>

       <div className="col-md-4 d-flex justify-content-center">
        <label
         style={{
          fontWeight: "bold",
          color: "#295a68",
          fontSize: "30px",
         }}
         className="product-page-details product-right mb-2 text-uppercase font-weight-bold"
        >
         {change_Lang("Payment bills")}
        </label>
       </div>
       <div className="col-md-4 d-flex justify-content-end">
        <div className="product-price digits form-group row">
         <div className="col-sm-4">
          <label
           style={{
            fontSize: "18px",
            fontWeight: "bold",
            color: "#295a68",
           }}
           className=" col-form-label fk"
          >
           {change_Lang("date")}:
          </label>
         </div>
         <div className="col-sm-8 d-flex justify-content-start text-right">
          {updated !== false ? (
           <Time
            value={view_paradan_obj.createdAt}
            format="YYYY-MM-DD"
            style={{
             color: "#295a68",
             fontSize: "18px",
             fontWeight: "bold",
             border: "none",
            }}
            className="form-control fk d-flex justify-content-satrt text-right mt-1"
           />
          ) : (
           <input
            type="date"
            className="form-control"
            value={createdAt}
            name="createdAt"
            onChange={OnChangeHandler}
            autoComplete="off"
            style={{
             fontSize: "16px",
             borderBottomColor: "#3889c1",
            }}
           />
          )}
         </div>
        </div>
       </div>
      </div>
      <div className="row">
       <div className="col-sm-12">
        {updated !== false ? (
         <TabList
          style={{
           background: "white",
           fontSize: "20px",
          }}
          className={`${
           lang === "en"
            ? "nav nav-tabs tab-coupon d-flex justify-content-center"
            : "nav nav-tabs tab-coupon d-flex justify-content-center fk"
          }`}
         >
          {change_Lang(view_paradan_obj.type) ===
          change_Lang("Monthly rent invoice") ? (
           <Tab
            value={change_Lang("Monthly rent invoice")}
            className="nav-link"
           >
            {change_Lang("Monthly rent invoice")}
           </Tab>
          ) : change_Lang(view_paradan_obj.type) ===
            change_Lang("Service Bill") ? (
           <Tab className="nav-link">{change_Lang("Service Bill")}</Tab>
          ) : change_Lang(view_paradan_obj.type) ===
            change_Lang("Buy_Required_translation") ? (
           <Tab className="nav-link">
            {change_Lang("Buy_Required_translation")}
           </Tab>
          ) : change_Lang(view_paradan_obj.type) === change_Lang("Sell") ? (
           <Tab className="nav-link">{change_Lang("Sell")}</Tab>
          ) : change_Lang(view_paradan_obj.type) === change_Lang("Arabun") ? (
           <Tab className="nav-link">{change_Lang("Arabun")}</Tab>
          ) : change_Lang(view_paradan_obj.type) === change_Lang("comision") ? (
           <Tab className="nav-link">{change_Lang("comision")}</Tab>
          ) : change_Lang(view_paradan_obj.type) === change_Lang("investor") ? (
           <Tab className="nav-link">{change_Lang("investor")}</Tab>
          ) : (
           <Tab className="nav-link">{change_Lang("Insurance Bill")}</Tab>
          )}
         </TabList>
        ) : (
         <TabList
          style={{ background: "white" }}
          className={`${
           lang === "en"
            ? "nav nav-tabs tab-coupon d-flex justify-content-center"
            : "nav nav-tabs tab-coupon d-flex justify-content-center fk"
          }`}
         >
          <Tab value={change_Lang("Monthly rent invoice")} className="nav-link">
           {change_Lang("Monthly rent invoice")}
          </Tab>
          <Tab className="nav-link" onChange={OnChangeHandler}>
           {change_Lang("Service Bill")}
          </Tab>
          <Tab className="nav-link" onChange={OnChangeHandler}>
           {change_Lang("Insurance Bill")}
          </Tab>
          <Tab className="nav-link" onChange={OnChangeHandler}>
           {change_Lang("Sell")}
          </Tab>
          <Tab className="nav-link" onChange={OnChangeHandler}>
           {change_Lang("Buy_Required_translation")}
          </Tab>
          <Tab className="nav-link" onChange={OnChangeHandler}>
           {change_Lang("Arabun")}
          </Tab>
          <Tab className="nav-link" onChange={OnChangeHandler}>
           {change_Lang("comision")}
          </Tab>
          <Tab className="nav-link" onChange={OnChangeHandler}>
           {change_Lang("investor")}
          </Tab>
         </TabList>
        )}
       </div>
      </div>
      <div className="row mb-4 ">
       <div className="col-sm-6  ">
        <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
         <div className="col-sm-4">
          <label
           style={{
            fontSize: "16px",
            color: "#295a68",
            fontWeight: "bold",
           }}
           className=" col-form-label fk"
          >
           {change_Lang("It was given to sir")}:
          </label>
         </div>
         <div className="col-sm-8">
          <input
           value={payer}
           name="payer"
           onChange={OnChangeHandler}
           disabled={updated !== false ? true : false}
           autoComplete="off"
           className="form-control fk text-center"
           style={{
            fontSize: "16px",
            borderBottomColor: "#3889c1",
           }}
          />
         </div>
        </div>
        <div className="product-price digits mt-2 form-group row ">
         <div className="col-sm-4 ">
          <label
           style={{
            fontSize: "18px",
            color: "#295a68",
            fontWeight: "bold",
           }}
           className=" col-form-label fk"
          >
           {change_Lang("Instead of")}:
          </label>
         </div>
         <div className="col-sm-8 ">
          {this.state.type !== change_Lang("investor") &&
          this.state.instead_of === "" ? (
           <>
            {this.state.type !== change_Lang("Monthly rent invoice") ? (
             <>
              <div className="row">
               <div className="col-sm-6">
                <input
                 type="text"
                 className="form-control fk"
                 value={this.state.type}
                 autoComplete="off"
                 disabled={true}
                 style={{
                  fontSize: "17px",
                  borderBottomColor: "#295a68",
                 }}
                />
               </div>
               <div className="col-sm-6 ">
                <PropertyesList
                 onChangeProperty={this.handleChange_Property}
                 valueOption={property}
                 disabled={updated !== false ? true : false}
                 size="large"
                />
               </div>
               <br />
               <br />
               <div className="col-sm-6">
                <input
                 type="text"
                 className="form-control fk"
                 value={place}
                 name="place"
                 onChange={OnChangeHandler}
                 disabled={updated !== false ? true : false}
                 maxLength={180}
                 autoComplete="off"
                 style={{
                  fontSize: "17px",
                  borderBottomColor: "#295a68",
                 }}
                />
               </div>

               <div className="col-sm-6 ">
                <input
                 type="text"
                 className="form-control fk"
                 value={num}
                 name="num"
                 onChange={OnChangeHandler}
                 disabled={updated !== false ? true : false}
                 maxLength={180}
                 autoComplete="off"
                 style={{
                  fontSize: "17px",
                  borderBottomColor: "#295a68",
                 }}
                 title="ok"
                />
               </div>
              </div>
             </>
            ) : (
             <>
              <div className="row">
               <div className="col-sm-6">
                <input
                 type="text"
                 className="form-control fk"
                 value={this.state.type}
                 disabled={true}
                 autoComplete="off"
                 style={{
                  fontSize: "17px",
                  borderBottomColor: "#295a68",
                 }}
                />
               </div>
               <div className="col-sm-6">
                <PropertyesList
                 onChangeProperty={this.handleChange_Property}
                 valueOption={property}
                 disabled={updated !== false ? true : false}
                 size="large"
                />
               </div>
               <br />
               <br />
               <div className="col-sm-6 ">
                <input
                 type="text"
                 className="form-control fk"
                 value={place}
                 name="place"
                 onChange={OnChangeHandler}
                 disabled={updated !== false ? true : false}
                 autoComplete="off"
                 style={{
                  fontSize: "17px",
                  borderBottomColor: "#295a68",
                 }}
                />
               </div>
               <div className="col-sm-6">
                <input
                 type="text"
                 className="form-control fk"
                 value={num}
                 name="num"
                 onChange={OnChangeHandler}
                 disabled={updated !== false ? true : false}
                 maxLength={180}
                 autoComplete="off"
                 style={{
                  fontSize: "17px",
                  borderBottomColor: "#295a68",
                 }}
                />
               </div>
               <br />
               <br />
               <div className="col-sm-6">
                <input
                 type="date"
                 className="form-control fk"
                 value={from}
                 name="from"
                 onChange={OnChangeHandler}
                 disabled={updated !== false ? true : false}
                 maxLength={180}
                 autoComplete="off"
                 style={{
                  fontSize: "17px",
                  borderBottomColor: "#295a68",
                 }}
                />
               </div>
               <div className="col-sm-6">
                <input
                 type="date"
                 className="form-control fk"
                 value={to}
                 name="to"
                 onChange={OnChangeHandler}
                 disabled={updated !== false ? true : false}
                 maxLength={180}
                 autoComplete="off"
                 style={{
                  fontSize: "17px",
                  borderBottomColor: "#295a68",
                 }}
                />
               </div>
              </div>
             </>
            )}
           </>
          ) : (
           <input
            type="text"
            className="form-control text-center fk"
            value={instead_of}
            name="instead_of"
            onChange={OnChangeHandler}
            disabled={updated !== false ? true : false}
            autoComplete="off"
            style={{
             fontSize: "17px",
             borderBottomColor: "#295a68",
            }}
           />
          )}
         </div>
        </div>
        <div className="product-price digits mt-2 form-group row ">
         <div className="col-sm-4 ">
          <label
           style={{
            fontSize: "18px",
            color: "#295a68",
            fontWeight: "bold",
           }}
           className=" col-form-label fk"
          >
           {change_Lang("received from Mr")}:
          </label>
         </div>
         <div className="col-sm-8 ">
          {box_status !== "on" ? (
           <input
            type="text"
            className="form-control fk text-center"
            value={reciver}
            autoComplete="off"
            name="reciver"
            onChange={OnChangeHandler}
            disabled={updated !== false ? true : false}
            style={{
             fontSize: "16px",
             borderBottomColor: "#3889c1",
            }}
           />
          ) : (
           <input
            type="text"
            className="form-control fk text-center"
            value={reciver}
            readOnly
            autoComplete="off"
            style={{
             fontSize: "16px",
             borderBottomColor: "#3889c1",
            }}
           />
          )}
         </div>
        </div>
        <br />
       </div>
       <div className="col-sm-6 ">
        <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
         <div className="col-sm-4">
          <label
           style={{
            fontSize: "18px",
            color: "#295a68",
            fontWeight: "bold",
           }}
           className=" col-form-label fk"
          >
           {change_Lang("money")}:
          </label>
         </div>
         <div className="col-sm-8">
          <NumberFormat
           displayType={`${updated !== true ? "input" : "text"}`}
           thousandSeparator={true}
           name="Amount"
           onChange={OnChangeHandler}
           disabled={updated !== false ? true : false}
           value={Amount}
           required
           className="form-control fk text-center"
           prefix={`${
            updated !== true ? "" : currency !== "dolar" ? "ID" : "$"
           }`}
           style={{
            fontSize: "16px",
            borderBottomColor: "#3889c1",
           }}
          />
         </div>
        </div>
        <div className="product-price digits form-group row">
         <div className="col-sm-4">
          <label
           style={{
            fontSize: "18px",
            color: "#295a68",
            fontWeight: "bold",
           }}
           className=" col-form-label fk"
          >
           {change_Lang("Currency Type")}:
          </label>
         </div>
         <div className="col-sm-8 d-flex justify-content-start text-right">
          {updated !== false ? (
           <input
            value={change_Lang(currency)}
            className="form-control fk text-center"
            style={{
             fontSize: "16px",
             borderBottomColor: "#3889c1",
            }}
           />
          ) : (
           <select
            value={currency}
            className="form-control  d-flex justify-content-start fk"
            onChange={OnChangeHandler}
            name="currency"
            style={{
             fontSize: "16px",
             borderBottomColor: "#3889c1",
            }}
           >
            <option value="">--{change_Lang("Choose")}--</option>
            <option value="dolar">{change_Lang("dolar")}</option>
            <option value="dinar">{change_Lang("dinar")}</option>
           </select>
          )}
         </div>
        </div>
        {/* box status */}
        <div className="product-price digits form-group row">
         <div className="col-sm-4">
          <label
           style={{
            fontSize: "12px",
            color: "#295a68",
            fontWeight: "bold",
           }}
           className=" col-form-label fk"
          >
           {change_Lang("Is the money going to go out of the box؟")}:
          </label>
         </div>
         <div className="col-sm-8 d-flex justify-content-start text-right">
          {updated !== false ? (
           <input
            value={
             box_status !== "off" ? change_Lang("Yes") : change_Lang("No")
            }
            className="form-control fk text-center"
            style={{
             fontSize: "16px",
             borderBottomColor: "#3889c1",
            }}
           />
          ) : (
           <select
            value={box_status}
            className="form-control  d-flex justify-content-start fk"
            onChange={OnChangeHandler}
            name="box_status"
            style={{
             fontSize: "16px",
             borderBottomColor: "#3889c1",
            }}
           >
            <option value="">{change_Lang("Choose")}</option>
            <option value="on">{change_Lang("Yes")}</option>
            <option value="off">{change_Lang("No")}</option>
           </select>
          )}
         </div>
        </div>
        {/* notes */}
        <div className="product-price digits mt-2 d-flex justify-content-start form-group row">
         <div className="col-sm-4">
          <label
           style={{
            fontSize: "18px",
            color: "#295a68",
            fontWeight: "bold",
           }}
           className=" col-form-label fk"
          >
           {change_Lang("note")}:
          </label>
         </div>
         <div className="col-sm-8">
          <input
           value={note}
           name="note"
           onChange={OnChangeHandler}
           disabled={updated !== false ? true : false}
           autoComplete="off"
           className="form-control fk text-center"
           style={{
            fontSize: "16px",
            borderBottomColor: "#3889c1",
           }}
          />
         </div>
        </div>
       </div>
      </div>
      <div className="row">
       <div className="col-md-4"></div>
       <div className="col-md-4">
        {user.u_bill !== false ? (
         updated !== false ? (
          <Button
           className="fk px-4"
           type="primary"
           shape="round"
           style={{
            background: "#d7e4eb",
            color: "#4b85a4",
            border: "none",
            outline: "none",
           }}
           htmlType="submit"
           onClick={onOpenUpdate}
          >
           {change_Lang("profile_updatebt")}&nbsp;
           <i className="fa fa-lock" style={{ fontSize: "14px" }}></i>
          </Button>
         ) : (
          <Button
           className="fk px-4"
           type="primary"
           shape="round"
           style={{
            background: "#d7e4eb",
            color: "#4b85a4",
            border: "none",
            outline: "none",
           }}
           htmlType="submit"
           onClick={onCloseUpdate}
          >
           {change_Lang("profile_updatebt")}&nbsp;
           <i className="fa fa-lock-open" style={{ fontSize: "14px" }}></i>
          </Button>
         )
        ) : (
         ""
        )}
       </div>
       <div className="col-md-4"></div>
      </div>
     </>
    </Tabs>
   </Fragment>
  );
 }
}

export default ViewParadan;
